import React from 'react'
import { observer } from 'mobx-react'
import { Redirect } from 'react-router'
import { Routes } from '../routes/AppRoutes'
import { route } from '../routes/routes'
import { RouteComponentProps } from 'react-router-dom'

const PaymentPlanRedirectView = observer(
  class PaymentPlanRedirectView extends React.Component<RouteComponentProps<{slug: string}>> {
    render () {
      return <Redirect to={route(`/${this.props.match.params.slug}${Routes.paymentPlan}${window.location.search}`)}/>
    }
  }
);

export default PaymentPlanRedirectView
